import React, {useEffect} from 'react';

import FormControl from '@mui/joy/FormControl';
import Grid from '@mui/joy/Grid';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';

// Icon
import IcoMultiple from '@mui/icons-material/TimesOneMobiledata';


export default function ATR(props) {	
	const [atr, setAtr] = React.useState(0);
	
	useEffect(() => {
		props.handleClick(props.activeCard && atr > 0, atr);			
	}, [props.activeCard]);

	function handleChange(e) {
		setAtr(e.target.value);
		props.handleClick(props.activeCard && e.target.value > 0, e.target.value);	
	}

	return (
	    <FormControl>
	    	<Grid container xs={4}>
	            <FormLabel>Multiple</FormLabel>
				<Input type="number" variant="solid" autoFocus disabled={!props.activeCard} size="lg" startDecorator={<IcoMultiple />} onChange={(e) => {handleChange(e);}} onWheel={(e) => e.target.blur()}/>
			</Grid>
		</FormControl>
	)
}